<template>
  <div class="page">
    <div class="page-bd">
      <!-- 面包屑导航 -->
      <el-row type="flex" justify="space-between" class="breadcrumb">
        <div>
          <img src="~@/assets/images/programme-home.png" class="icon-home">
          <span style="margin-right: 25px;">{{ $route.meta.title }}</span>
          <span>管理方案</span>
          <span style="margin-left: 5px;margin-right: 5px;">></span>
          <span>设计方案</span>
          <span style="margin-left: 5px;margin-right: 5px;">></span>
          <span>{{ studentInfo[0].batch }}</span>
        </div>
        <el-row type="flex" align="middle">
          <span>{{ user.name }}</span>
          <span style="margin: 0 33px;">{{ user.sex == 0 ? "男" : "女" }}</span>
          <span style="margin: 0 5px;">
            <span v-if="studentInfo[0].majorType == 1">物理</span>
            <span v-if="studentInfo[0].majorType == 2">历史</span>
          </span>
					<span style="margin: 0 5px;">{{ user.subject1 }}</span>
					<span style="margin: 0 5px;">{{ user.subject2 }}</span>
					<span style="margin: 0 5px;" v-if="user.score">分数:{{ user.score }}</span>
					<span style="margin: 0 5px;" v-if="user.precedence">位次:{{ user.precedence }}</span>
          <span style="margin: 0 10px;" v-if="user.schemeRemark">{{ user.schemeRemark }}</span>
        </el-row>
      </el-row>
      <div class="page-block">
        <!-- 首选科目行 -->
        <el-row type="flex">
          <!-- 理科: 理科、艺术理 文史: 文史、艺术文  -->
					<div class="queryParams-row1" style="margin-right: 50px;">
						<span class="queryParams-row1__label font-strong">首选科目</span>
						<el-radio-group v-model="queryParams.majorType" class="queryParams-row1__group">
							<el-radio label="1" :disabled="queryParams.majorType != '1'">物理</el-radio>
							<el-radio label="2" :disabled="queryParams.majorType != '2'" >历史</el-radio>
						</el-radio-group>
					</div>
					<div class="queryParams-row1">
						<span class="queryParams-row1__label font-strong">再选科目</span>
						<el-checkbox-group v-model="queryParams.subject" :max="2" class="queryParams-row1__group">
							<el-checkbox :disabled="true" v-for="item in secondarilySubjects" :label="item.value" :key="item.value">
								{{ item.label }}
							</el-checkbox>
						</el-checkbox-group>
					</div>

          <el-tabs class="ui-tabs" @tab-click="getTableData" v-model="tabs.active" style="flex: 1; min-width: 0;margin-right: 0;margin-left: 18px">
            <el-tab-pane disabled v-for="item in tabs.list" :key="item.id" :label="item.label" :name="item.value" sytle="padding: 0 20px;">
							<span slot="label">
								{{ item.label }}
							</span>
            </el-tab-pane>
          </el-tabs>
        </el-row>
        <!-- 院校搜索区 -->
        <SearchCollapsePanel ref="searchPanel"
                             :city.sync="queryParams.city"
                             :type.sync="queryParams.type"
                             :nature.sync="queryParams.nature"
                             :hierarchys.sync="queryParams.hierarchys"
                             :qualifications.sync="queryParams.qualifications"
                             :queryParams.sync="queryParams"
                             :tabs.sync="tabs"
                             :fromPage="'seniorSchool'"
                             @refresh-table="getTableData"
        >
          <template #handle>
            <el-dropdown @command="sortTable">
              <el-button style="margin-right: 10px;"  type="primary" size="medium">
                {{ queryParams.sortType | sortType2CN }}<i class="el-icon-arrow-down el-icon--right"></i>
              </el-button>
              <el-dropdown-menu slot="dropdown">
                <el-dropdown-item v-for="item in sortTypes" :key="item.value" :command="item.value">{{ item.label }}</el-dropdown-item>
              </el-dropdown-menu>
            </el-dropdown>
            <el-button type="primary" @click="queryParams.queryType = 1;getTableData()" size="medium">定位查询</el-button>
            <el-button type="primary" @click="queryParams.queryType = 2;getTableData()" size="medium">筛选查询</el-button>
            <el-button @click="handleReset()" size="medium">重置</el-button>
            <span v-if="queryParams.queryType === 1 && searchResult.list.length > 0" style="margin-left: 30px;margin-right: 15px;color: var(--primaryColor);">
              <span style="font-size: 14px; font-weight: 500;">
                检索结果  {{ getSearchIndexByCurrentCode(searchResult.currentCode) }} / {{ searchResult.list.length }}
              </span>
              <span style="font-size: 16px; cursor: pointer;">
                <span @click="toNextResultFn(-1)"><i class="el-icon-arrow-up searchResult-icon"></i></span>
                <span @click="toNextResultFn(1)" style="margin-left: 4px"><i class="el-icon-arrow-down searchResult-icon"></i></span>
              </span>
            </span>
            <span v-if="queryParams.queryType === 2" style="margin-left: 30px;margin-right: 15px;color: var(--primaryColor);">
              <span style="font-size: 14px; font-weight: 500;">
                检索结果  {{ tableData.length }}
              </span>
            </span>
          </template>
        </SearchCollapsePanel>
      </div>
			<!-- 表格区 -->
			<div style="margin: auto;overflow:auto">
				<!-- 普通 -->
				<virtual-scroll v-if="ptfrom" key="virtualScroll1"
					ref="virtualScroll"
          empty-text="无匹配结果"
					:data="tableData"
					:item-size="48"
					key-prop="id"
					@change="virtualList => (virtualScroll.tableData = virtualList)">
					<el-table class="ui-table" height="750px" row-key="id"
						v-loading="tableDataLoading" ref="multipleTable" :data="virtualScroll.tableData" :cell-style="cellStyle"
						:header-cell-style="{'text-align':'center'}"
						:row-class-name="tableTrClassName">
            <ColProbabilityTea label="录取概率" align="center" />
						<el-table-column prop="code" label="招生代码" width="96" align="center">
							<template slot-scope="props">
								<div @click="toggleExpand(props.row, props.$index)" :class="setCurrentCodeFontColor(props.row.code + '-' + props.row.groupCode)" style="cursor: pointer;">
									{{ props.row.code }}-{{ props.row.groupCode }}
									<i v-show="props.isExpanded" style="color: #ccc;" class="el-icon-caret-bottom"></i>
									<i v-show="!props.isExpanded" style="color: #ccc;" class="el-icon-caret-right"></i>
								</div>
								<img v-if="props.row.isNewSchool == 1" src="~@/assets/images/icon-new-major.png" class="tag-new" />
							</template>
						</el-table-column>
						<el-table-column prop="schoolName" label="招生院校" align="left">
							<template slot-scope="scope">
                <div style="width: 100%;display: flex;align-items: flex-start;padding: 0 10px">
                  <img v-if="scope.row.limitFlag" class="tag-limit-school" src="~@/assets/images/icon_shouxian.png" alt="icon" >
                  <div style="flex: 1;padding-left: 20px">
                    <div>
                      <span @click="details(scope.row)" style="cursor: pointer;font-size: 14px;font-weight:600; display: inline;padding-left: 6px;"
                            v-html="showDate(scope.row.schoolName, '普通')"></span>
                      <img class="school-name-icon" title="查看院校全部专业组" src="~@/assets/images/icon-preview.png" alt="icon" @click="openAllMajorDialog(scope.row)">
                    </div>
                    <div class="name-tag" v-if="scope.row.level || scope.row.city || scope.row.manager || scope.row.levelMsg">
                      <span>{{ scope.row.level }}</span>
                      <span>{{ scope.row.city }}</span>
                      <span>{{ scope.row.manager }}</span>
                      <span v-if="scope.row.levelMsg != ''">{{ scope.row.levelMsg }}</span>
                    </div>
                    <div class="name-tag">
                      <span :style="{ color: scope.row.majorPlan === '专业清' || scope.row.majorPlan === '一专再分' ? 'red' : '' }">{{ scope.row.majorPlan }}</span>
                      <span>排名:{{ scope.row.sortNum }}</span>
                      <span v-if="scope.row.rateGraduate != ''">{{ scope.row.rateGraduate }}</span>
                    </div>
                  </div>
                  <img width="22" height="18" src="~@/assets/images/icon_zhu.png" alt="icon" style="cursor: pointer; margin-top: 3px;" @click="introduceSchool(scope.row.code)">
                </div>
							</template>
						</el-table-column>
						<el-table-column align="center" prop="groupCode" label="专业数" width="66">
              <template slot-scope="scope">
                <span class="font-strong">{{ scope.row.majorNum }}</span>
              </template>
            </el-table-column>
						<el-table-column align="center" prop="subject" :render-header="renderHeader" label="再选/要求" width="72"></el-table-column>
						<el-table-column align="center" prop="recruitType" :render-header="renderHeader" label="类别" width="66">
              <template slot-scope="scope">
                <span :class="scope.row.recruitType == '中外合办' ? 'txt-red' : ''">{{ scope.row.recruitType }}</span>
              </template>
            </el-table-column>

            <el-table-column prop="toudang2015" label="计划数|录取数" class-name="mergeTh" align="center">
              <el-table-column prop="toudang2019" :label="nowYear - 2 + ''" class-name="mergeTh-child" align="center" width="66px"></el-table-column>
              <el-table-column prop="toudang2020" :label="nowYear - 1 + ''" class-name="mergeTh-child" align="center" width="66px"></el-table-column>
              <el-table-column prop="toudang2021" :label="nowYear + ''" class-name="mergeTh-child" align="center" width="66px">
                <template slot-scope="scope">
                  <span class="font-strong">{{ scope.row.toudang2021 }}</span>
                </template>
              </el-table-column>
            </el-table-column>

						<el-table-column prop="shift_line2019" label="录取线（含征集）" align="center" class-name="mergeTh">
							<el-table-column align="center" class-name="mergeTh-child" prop="shiftLine2019" :label="nowYear - 2 + ''" width="56px"></el-table-column>
							<el-table-column align="center" class-name="mergeTh-child" prop="shiftLine2020" :label="nowYear - 1 + ''" width="56px"></el-table-column>
							<el-table-column align="center" class-name="mergeTh-child" prop="shiftLine2021" :label="nowYear + ''" width="56px">
								<template slot-scope="scope">
									<span class="font-strong">{{ scope.row.shiftLine2021 }}</span>
								</template>
							</el-table-column>
						</el-table-column>
						<el-table-column prop="ranking2019" label="录取位次" align="center" class-name="mergeTh">
							<template slot="header" slot-scope="scope">
								<span>录取位次</span>
								<el-tooltip effect="dark" placement="top">
									<div slot="content">数据说明：<br/>带下划线为录取分数的同分最低位，不带下划线为录取分数的精准位次。<br/>- 代表暂无数据。</div>
									<img src="~@/assets/images/shiftLineFlag.png" alt="icon" style="height: 16px; width: auto; margin-left: 4px; vertical-align: middle; cursor: pointer;">
								</el-tooltip>
							</template>
							<el-table-column align="center" class-name="mergeTh-child" prop="ranking2019" :label="nowYear - 2 + ''" width="80"></el-table-column>
							<el-table-column align="center" class-name="mergeTh-child" prop="ranking2020" :label="nowYear - 1 + ''" width="80"></el-table-column>
							<el-table-column align="center" class-name="mergeTh-child" prop="ranking2021" :label="nowYear + ''" width="80">
								<template slot-scope="scope">
									<span class="font-strong" :style="{ textDecoration: scope.row.ranking2021Flag == 1 ? 'underline' : 'none' }">{{ scope.row.ranking2021 }}</span>
								</template>
							</el-table-column>
						</el-table-column>
<!--						<el-table-column align="center" prop="sortNum" :render-header="renderHeader" label="院校/排名" width="56px"></el-table-column>-->

						<el-table-column align="center" prop="plan2022" :label="PlanYear + '计划'" width="65px">
							<template slot-scope="scope">
								<span v-if="scope.row.plan2022 > scope.row.plan2021" class="icon-top">
									{{ scope.row.plan2022 }}<i>↑</i>
								</span>
								<span v-else-if="scope.row.plan2021 > scope.row.plan2022" class="icon-bottom">
									{{ scope.row.plan2022 }}<i>↓</i>
								</span>
								<span v-else>{{ scope.row.plan2022 }}</span>
							</template>
						</el-table-column>
						<el-table-column align="center" prop="zy" label="填报" width="90">
							<template slot="header" slot-scope="scope">
								填报
							</template>
							<template slot-scope="scope">
								<el-checkbox @change="(value) => schemeChange(value, scope)" v-model="scope.row._schemeChecked">
                  {{ scope.row._schemeChecked ? `已选${scope.row.schemeNum}` : '选择' }}
                </el-checkbox>
							</template>
						</el-table-column>
						<!-- 展开后的表格 -->
						<virtual-column type="expand" width="1">
							<template slot-scope="props">
								<el-table class="ui-expandTable" :data="props.row.children1"
									:cell-style="cellStyles" :header-cell-style="{'text-align':'center'}">
                  <ColProbabilityTea label="录取概率" align="center" />
									<el-table-column align="center" prop="majorCode" label="专业代码" width="95">
                    <template slot-scope="scope">
                      <div style="position: relative;">
                        <div>{{ scope.row.majorCode }}</div>
                        <img v-if="scope.row.limitFlag" class="tag-limit" src="~@/assets/images/icon_shouxian.png" alt="icon" >
                      </div>
                      <img v-if="scope.row.isNewMajor == 1" src="~@/assets/images/icon-new-major.png" class="tag-new" />
                    </template>
                  </el-table-column>
									<el-table-column prop="majorName" label="专业名称(包含专业及等级排名)" min-width="380">
										<template slot-scope="scope">
											<el-row type="flex" style="text-align: left; margin-right: 2em;">
												<span style="font-size: 14px; margin-right: 0.5em; flex: 1;" v-html="showDate(scope.row.majorName, '普通')"></span>
												<!-- row.color === 'red' -->
                        <img v-if="scope.row.majorDesc" width="22" height="18" src="~@/assets/images/icon_zhu.png" alt="icon" style="margin-left: 10px;cursor: pointer" @click="introduceMajor(scope.row.majorDesc)">
											</el-row>
										</template>
									</el-table-column>
									<el-table-column prop="msg2015" label="计划数 / 录取数  |  最高分 / 平均分 / 最低分| 最高位次-最低位次" class-name="mergeTh" align="center">
										<el-table-column prop="msg2015" :label="MajorNowYear - 2 + ''" class-name="mergeTh-child" width="230" align="center"></el-table-column>
										<el-table-column prop="msg2016" :label="MajorNowYear - 1 + ''" class-name="mergeTh-child" width="230" align="center"></el-table-column>
										<el-table-column prop="msg2017" :label="MajorNowYear + ''" class-name="mergeTh-child" width="230" align="center"></el-table-column>
									</el-table-column>
									<el-table-column prop="plan2018" :label="MajorPlanYear + '计划'" width="50" align="center">
										<template slot-scope="scope">
											<span v-if="scope.row.plan2018 > scope.row.plan2017" class="icon-top">{{ scope.row.plan2018 }}↑</span>
											<span v-else-if="scope.row.plan2017 > scope.row.plan2018" class="icon-bottom">{{ scope.row.plan2018 }}↓</span>
											<span v-else>{{ scope.row.plan2018 }}</span>
										</template>
									</el-table-column>
									<el-table-column label="操作" style="padding: 0;" align="center" width="90">
										<template slot-scope="propss" style="padding: 0;">
											<el-dropdown trigger="click" style="margin: 0;padding: 0;">
												<span class="el-dropdown-link" :class="propss.row.sort ? 'scheme' : 'not-scheme'"
													style="font-size: 14px;margin: 0;cursor: pointer;">
													{{ propss.row.sort ? propss.row.sort : '选择' }}
												</span>
												<i class="el-icon-caret-bottom"></i>
												<el-dropdown-menu slot="dropdown">
													<el-dropdown-item v-for="(item, index) in majorList" :key="index" :command="item.label"
														style="padding: 0;text-align: center;">
														<span :style="majorDisabled.includes(props.row.code+'_'+props.row.groupCode+'_'+item.label) ? 'color: #c0c4cc;': ''"
															@click="!majorDisabled.includes(props.row.code+'_'+props.row.groupCode+'_'+item.label)
																				? majorchange(props.row, propss.row, item.label)
																				: () => {}"
															style="width: 60px;padding: 10px;">{{ item.label }}</span>
													</el-dropdown-item>
												</el-dropdown-menu>
											</el-dropdown>
										</template>
									</el-table-column>
								</el-table>
							</template>
						</virtual-column>
					</el-table>
				</virtual-scroll>
				<!-- 提前批次 -->
				<virtual-scroll v-if="tqfrom" key="virtualScroll2"
					ref="virtualScroll"
          empty-text="无匹配结果"
					:data="tableData"
					:item-size="48"
					key-prop="id"
					@change="virtualList => (virtualScroll.tableData = virtualList)">
					<el-table class="ui-table" height="750px" row-key="id"
						v-loading="tableDataLoading"
						ref="multipleTable2"
						:data="virtualScroll.tableData"
						:cell-style="cellStyle"
						:header-cell-style="{'text-align':'center'}"
						:row-class-name="tableTrClassName">
            <ColProbabilityTea label="录取概率" align="center" />
						<el-table-column prop="code" label="院校代码" width="96" align="center">
							<template slot-scope="props">
								<div @click="toggleExpand(props.row, props.$index)" :class="setCurrentCodeFontColor(props.row.code + '-' + props.row.groupCode)" style="cursor: pointer;">
									{{ props.row.code }}-{{ props.row.groupCode }}
									<i v-show="props.isExpanded" style="color: #ccc;" class="el-icon-caret-bottom"></i>
									<i v-show="!props.isExpanded" style="color: #ccc;" class="el-icon-caret-right"></i>
								</div>
                <img v-if="props.row.isNewSchool == 1" src="~@/assets/images/icon-new-major.png" class="tag-new" />
							</template>
						</el-table-column>
						<el-table-column prop="schoolName" label="招生院校" min-width="150px" align="left">
							<template slot-scope="scope">
                <div style="width: 100%;display: flex;align-items: flex-start;padding: 0 10px">
                  <img v-if="scope.row.limitFlag" class="tag-limit-school" src="~@/assets/images/icon_shouxian.png" alt="icon" >
                  <div style="flex: 1;padding-left: 20px">
                    <div>
                      <span @click="details(scope.row)" style="cursor: pointer;font-size: 14px;font-weight:600; display: inline;padding-left: 6px;"
                            v-html="showDate(scope.row.schoolName, '普通')"></span>
                      <img class="school-name-icon" title="查看院校全部专业" src="~@/assets/images/icon-preview.png" alt="icon" @click="openAllMajorDialog(scope.row)">
                    </div>
                    <div class="name-tag" v-if="scope.row.level || scope.row.city || scope.row.manager || scope.row.levelMsg">
                      <span>{{ scope.row.level }}</span>
                      <span>{{ scope.row.city }}</span>
                      <span>{{ scope.row.manager }}</span>
                      <span v-if="scope.row.levelMsg != ''">{{ scope.row.levelMsg }}</span>
                    </div>
                    <div class="name-tag">
                      <span :style="{ color: scope.row.majorPlan === '专业清' || scope.row.majorPlan === '一专再分' ? 'red' : '' }">{{ scope.row.majorPlan }}</span>
                      <span v-if="scope.row.rateGraduate != ''">{{ scope.row.rateGraduate }}</span>
                    </div>
                  </div>
                  <img width="22" height="18" src="~@/assets/images/icon_zhu.png" alt="icon" style="cursor: pointer; margin-top: 3px;" @click="introduceSchool(scope.row.code)">
                </div>
							</template>
						</el-table-column>

						<el-table-column align="center" prop="groupCode" label="专业数" width="66">
              <template slot-scope="scope">
                <span class="font-strong">{{ scope.row.majorNum }}</span>
              </template>
            </el-table-column>
						<el-table-column align="center" prop="subject" :render-header="renderHeader" label="再选/要求" width="72"></el-table-column>
						<el-table-column align="center" prop="schoolCate" :render-header="renderHeader" label="类别" width="66"></el-table-column>

						<el-table-column prop="toudang2015" label="计划数|录取数" class-name="mergeTh" align="center">
							<el-table-column prop="toudang2019" :label="nowYear - 2 + ''" class-name="mergeTh-child" align="center" min-width="40px"></el-table-column>
							<el-table-column prop="toudang2020" :label="nowYear - 1 + ''" class-name="mergeTh-child" align="center" min-width="40px"></el-table-column>
							<el-table-column prop="toudang2021" :label="nowYear + ''" class-name="mergeTh-child" align="center" min-width="56px">
								<template slot-scope="scope">
									<span class="font-strong">{{ scope.row.toudang2021 }}</span>
								</template>
							</el-table-column>
						</el-table-column>

						<el-table-column prop="fluctuation2019" label="录取线（含征集）" class-name="mergeTh" align="center">
							<el-table-column prop="shiftLine2019" :label="nowYear - 2 + ''" class-name="mergeTh-child" align="center" min-width="50px"></el-table-column>
							<el-table-column prop="shiftLine2020" :label="nowYear - 1 + ''" class-name="mergeTh-child" align="center" min-width="50px"></el-table-column>
							<el-table-column prop="shiftLine2021" :label="nowYear + ''" class-name="mergeTh-child" align="center" min-width="56px">
								<template slot-scope="scope">
									<span class="font-strong">{{ scope.row.shiftLine2021 }}</span>
								</template>
							</el-table-column>
						</el-table-column>
						<el-table-column prop="ranking2019" label="录取位次" class-name="mergeTh" align="center">
							<template slot="header" slot-scope="scope">
								<span>录取位次</span>
								<el-tooltip effect="dark" placement="top">
									<div slot="content">数据说明：<br/>带下划线为录取分数的同分最低位，不带下划线为录取分数的精准位次。<br/>- 代表暂无数据。</div>
									<img src="~@/assets/images/shiftLineFlag.png" alt="icon" style="height: 16px; width: auto; margin-left: 4px; vertical-align: middle; cursor: pointer;">
								</el-tooltip>
							</template>
							<el-table-column prop="ranking2019" :label="nowYear - 2 + ''" class-name="mergeTh-child" align="center" min-width="40px"></el-table-column>
							<el-table-column prop="ranking2020" :label="nowYear - 1 + ''" class-name="mergeTh-child" align="center" min-width="40px"></el-table-column>
							<el-table-column prop="ranking2021" :label="nowYear + ''" class-name="mergeTh-child" align="center" min-width="42px">
								<template slot-scope="scope">
									<span class="font-strong" :style="{ textDecoration: scope.row.ranking2021Flag == 1 ? 'underline' : 'none' }">{{ scope.row.ranking2021 }}</span>
								</template>
							</el-table-column>
						</el-table-column>
						<el-table-column prop="plan2022" :label="PlanYear + '计划'" width="65px" align="center">
							<template slot-scope="scope">
								<span v-if="scope.row.plan2022 > scope.row.plan2021" class="icon-top">
									{{ scope.row.plan2022 }}<i>↑</i>
								</span>
								<span v-else-if="scope.row.plan2021 > scope.row.plan2022" class="icon-bottom">
									{{ scope.row.plan2022 }}<i>↓</i>
								</span>
								<span v-else>{{ scope.row.plan2022 }}</span>
							</template>
						</el-table-column>
						<el-table-column prop="zy" label="填报" width="90" align="center">
							<template slot="header" slot-scope="scope">
								填报{{ schoolCheckedNumber }}
							</template>
							<template slot-scope="scope">
								<el-checkbox
									@change="(value) => schemeChange(value, scope)"
									v-model="scope.row._schemeChecked">
									{{ scope.row._schemeChecked ? `已选${scope.row.schemeNum}` : '选择' }}
								</el-checkbox>
							</template>
						</el-table-column>
						<!-- 展开后的表格 -->
						<virtual-column type="expand" width="1">
							<template slot-scope="props">
								<el-table class="ui-expandTable" :data="props.row.children1"
									:cell-style="cellStyles" :header-cell-style="{'text-align':'center'}">
                  <ColProbabilityTea label="录取概率" align="center" />
                  <el-table-column prop="majorCode" label="专业代码" width="95" align="center">
                    <template slot-scope="scope">
                      <div style="position: relative;">
                        <div>{{ scope.row.majorCode }}</div>
                        <img v-if="scope.row.limitFlag" class="tag-limit" src="~@/assets/images/icon_shouxian.png" alt="icon" >
                      </div>
                      <img v-if="scope.row.isNewMajor == 1" src="~@/assets/images/icon-new-major.png" class="tag-new" />
                    </template>
                  </el-table-column>
									<el-table-column prop="majorName" label="专业名称(包含专业及等级排名)" min-width="380">
										<template slot-scope="scope">
											<el-row type="flex" style="text-align: left; margin-right: 2em;">
												<span style="font-size: 14px; margin-right: 0.5em; flex: 1;" v-html="showDate(scope.row.majorName, '普通')"></span>
												<!-- row.color === 'red' -->
                        <img v-if="scope.row.majorDesc" width="22" height="18" src="~@/assets/images/icon_zhu.png" alt="icon" style="margin-left: 10px;cursor: pointer" @click="introduceMajor(scope.row.majorDesc)">
											</el-row>
										</template>
									</el-table-column>
									<el-table-column prop="msg2015" label="计划数 / 录取数 | 最高分 / 平均分 / 最低分 | 最高位次-最低位次" class-name="mergeTh" align="center">
										<el-table-column prop="msg2015" :label="MajorNowYear - 2 + ''" class-name="mergeTh-child" align="center" width="230"></el-table-column>
										<el-table-column prop="msg2016" :label="MajorNowYear - 1 + ''" class-name="mergeTh-child" align="center" width="230"></el-table-column>
										<el-table-column prop="msg2017" :label="MajorNowYear + ''" class-name="mergeTh-child" align="center" width="230"></el-table-column>
									</el-table-column>
									<el-table-column prop="plan2018" :label="MajorPlanYear + '计划'" width="50" align="center">
										<template slot-scope="scope">
											<span v-if="scope.row.plan2018 > scope.row.plan2017" class="icon-top">{{ scope.row.plan2018 }}↑</span>
											<span v-else-if="scope.row.plan2017 > scope.row.plan2018" class="icon-bottom">{{ scope.row.plan2018 }}↓</span>
											<span v-else>{{ scope.row.plan2018 }}</span>
										</template>
									</el-table-column>
									<el-table-column label="操作" min-width="9px" style="padding: 0;" align="center" width="90">
										<template slot-scope="propss" style="padding: 0;">
											<!-- <el-checkbox @change="(value) => onChangeMajor(value, { parentRow: props, childRow: propss })" v-model="propss.row._isChecked">{{ propss.row._isChecked ? '已选' : '选择' }}</el-checkbox> -->
											<el-dropdown trigger="click" style="margin: 0;padding: 0;">
												<span class="el-dropdown-link" :class="propss.row.sort ? 'scheme' : 'not-scheme'"
													style="font-size: 14px;margin: 0;cursor: pointer;">
													{{ propss.row.sort ? propss.row.sort : '选择' }}
												</span>
												<i class="el-icon-caret-bottom"></i>
												<el-dropdown-menu slot="dropdown">
													<el-dropdown-item v-for="(item, index) in majorList" :key="index" :command="item.label"
														style="padding: 0;text-align: center;">
														<span :style="majorDisabled.includes(props.row.code+'_'+props.row.groupCode+'_'+item.label) ? 'color: #c0c4cc;': ''"
															@click="!majorDisabled.includes(props.row.code+'_'+props.row.groupCode+'_'+item.label)
																				? majorchange(props.row, propss.row, item.label)
																				: () => {}"
															style="width: 60px;padding: 10px;">{{ item.label }}</span>
													</el-dropdown-item>
												</el-dropdown-menu>
											</el-dropdown>
										</template>
									</el-table-column>
								</el-table>
							</template>
						</virtual-column>
					</el-table>
				</virtual-scroll>
			</div>
			<!-- 学校简介 -->
			<el-dialog :visible.sync="schoolIntroduce.open" :close-on-click-modal="false" class="school-info-dialog">
        <div class="school-info-remark" >
          重要声明：本系统院校及专业备注信息均源自各校官网、官微、公开说明及招生计划汇编，可能存在院校临时调整或不可落地的情况，仅供参考。如作为填报依据，请务必向相关院校核实。本系统不作任何保证，不承担任何法律责任。
        </div>
        <div v-if="schoolIntroduce.type === 'major'" v-html="schoolIntroduce.data" style="cursor: pointer;font-size: 16px;width: 100%;margin: auto;color: #000000;">
        </div>
        <div class="school-info-container" v-if="schoolIntroduce.type === 'school'">
          <div class="school-info-card">
            <div class="card-title">院校简介</div>
            <div class="card-content" v-html="schoolIntroduce.schoolDesc"></div>
          </div>
          <div class="school-info-card">
            <div class="card-title">招生政策</div>
            <div class="card-content" v-html="schoolIntroduce.policy"></div>
          </div>
          <div class="school-info-card">
            <div class="card-title">特殊班型</div>
            <div class="card-content" v-html="schoolIntroduce.specialClass"></div>
          </div>
          <div class="school-info-card">
            <div class="card-title">章程摘要</div>
            <div class="card-content" v-html="schoolIntroduce.constitution"></div>
          </div>
        </div>
			</el-dialog>
			<!-- 右侧悬浮 -->
			<div id="npt">
        <div style="background-color: #E04A4A;" @click="openStatementDialog()">
          <img class="icon" src="~@/assets/images/design/icon_preview.png" alt="icon" />
          <span>声明</span>
        </div>
				<div style="background-color: #D0B000;">
          <img class="icon" src="~@/assets/images/design/icon_school.png" alt="icon" />
          <span>{{ schoolCheckedNumber }}</span>
        </div>
				<div style="background-color: #5DBE2D;" @click="empty()">
          <img class="icon" src="~@/assets/images/design/icon_del.png" alt="icon" />
          <span>清空</span>
        </div>
				<div style="background-color: #E29345;" @click="saveScheme()">
          <img class="icon" src="~@/assets/images/design/icon_save.png" alt="icon" />
          <span>保存</span>
        </div>
				<div style="background-color: #E04A4A;" @click="handleClick()">
          <img class="icon" src="~@/assets/images/design/icon_preview.png" alt="icon" />
          <span>预览</span>
        </div>
        <div style="background-color: #1B94D2;" @click="openHealthDialog()">
          <img class="icon" src="~@/assets/images/design/icon_tijian.png" alt="icon" />
          <span>体检</span>
        </div>
				<div style="background-color: #415B8A;" @click="UpperLevel()">
          <img class="icon" src="~@/assets/images/design/icon_return.png" alt="icon" />
          <span>上一级</span>
        </div>
			</div>
    </div>

    <!--  体检限制弹窗  -->
    <health-dialog v-if="showHealthDialog" :healthVisible="showHealthDialog" @closeHealthDialog="closeHealthDialog"></health-dialog>
    <!--  免责声明弹窗  -->
    <statement-dialog v-if="showStatementDialog" :statementVisible="showStatementDialog" @closeStatementDialog="closeStatementDialog"></statement-dialog>
    <!--  院校全部专业弹窗  -->
    <all-major-desgin-dialog
      :visible.sync="allMajorVisible"
      :loading="allMajorLoading"
      :highlight-code="allMajorHighlightCode"
      :school-info="allMajorSchoolInfo"
      :batch-list="allMajorBatchList"
      :major-list="majorList"
      :now-year="nowYear"
      :plan-year="PlanYear"
      :major-now-year="MajorNowYear"
      :major-plan-year="MajorPlanYear"
      @schemeChange="(value, row) => dialogSchemeChange(value, row)"
      @majorChange="(parentRow, childRow, label) => dialogMajorChange(parentRow, childRow, label)"
      @introduceMajor="(majorDesc) => introduceMajor(majorDesc)"
      @introduceSchool="(code) => introduceSchool(code)"
      @close="closeAllMajorDialog">
    </all-major-desgin-dialog>
  </div>
</template>
<script>
import { request } from "@/util/request.js"
import VirtualScroll, { VirtualColumn } from 'el-table-virtual-scroll'
import healthDialog from "@/components/healthDialog.vue";
import SearchCollapsePanel from "@/components/SearchCollapsePanel/index.vue";
import StatementDialog from "@/components/statementDialog.vue";
import AllMajorDesginDialog from "@/components/allMajorDesginDialog.vue";

const natureOptions = [
	{ label: '不限', value: '不限' }, { label: '公办', value: '1' }, { label: '民办', value: '2' }, { label: '合办', value: '3' }
]
const HierarchyOptions = [
	{ label: '不限', value: '不限' }, { label: '双一流', value: '1' }, { label: '中央直管', value: '2' }, { label: '985', value: '3' }, { label: '211', value: '4' }, { label: '双高计划', value: '5' }, { label: '国家示范(骨干)', value: '6' }
]
const QualificationsOptions = [
	{ label: '不限', value: '不限' }, { label: '硕士点', value: '1' }, { label: '博士点', value: '2' }, { label: '研究生院', value: '3' }, { label: '自划线', value: '4' }, { label: '推免资格', value: '5' }
]
const defaultRecruitType = ['普通志愿','中外合办','定向就业']

export default {
	components: {
    SearchCollapsePanel,
		VirtualScroll,
		VirtualColumn,
    healthDialog,
    StatementDialog,
    AllMajorDesginDialog,
	},
  data() {
    return {
      searchResult: {
        currentCode: '',
        list: [],
      },

			virtualScroll: {
				tableData: [],
			},
			recruitType: {
				default: ['普通志愿', '中外合办', '定向就业'],
			},
			schoolCheckedNumber: '',
			schoolIntroduce: {
				open: false,
        schoolDesc: '', // 院校简介
        constitution: '', // 招生章程
        policy: '', // 招生政策
        specialClass: '', // 特殊班型
        warning: '', // 院校预警
			},
			nowYear: null, 			// 当前数据年份
			PlanYear: null,				// xx年计划
      MajorNowYear: null,				// xx年计划
      MajorPlanYear: null,				// xx年计划
      collapseOpen: false, // 展开收起标记
      studentInfo: [],
			secondarilySubjects: [
				{ label: '化学', value: '化学' },
				{ label: '生物', value: '生物' },
				{ label: '政治', value: '政治' },
				{ label: '地理', value: '地理' },
			],
      user: null,
			sortTypes: [
				{ value: 1, label: '按院校排序' },
				{ value: 2, label: '按专业组排序' },
			],
      tabs: {
        list: [
          {
            label: '本科提前批单设',
            value: '本科提前批单设',
            remark: '注：设1个院校专业组，每个专业组设6个专业',
            defaultRecruitType: ['军校招飞']
          },
          {
            label: '本科提前批平行',
            value: '本科提前批平行',
            remark: '注：设6个院校专业组，每个专业组设6个专业',
            defaultRecruitType: ['军队院校']
          },
          {
            label: '本科普通批平行',
            value: '本科普通批平行',
            remark: '注：设45个专业组，每组设6个专业',
            defaultRecruitType: ['普通志愿', '中外合办', '定向就业']
          },
          {
            label: '高职专科提前批',
            value: '高职专科提前批',
            remark: '注：设6个院校专业组，每个专业组设6个专业',
            defaultRecruitType: ['定向军士']
          },
          {
            label: '高职专科普通批',
            value: '高职专科普通批',
            remark: '注：设45个院校专业组，每个专业组设6个专业',
            defaultRecruitType: ['普通志愿', '中外合办']
          },
        ],
				active: '本科普通批平行',
			},
      cities: this.$constants.provinces,
			SchoolTypes: this.$constants.schoolTypes,
			Natures: natureOptions,
			Hierarchys: HierarchyOptions,
			Qualifications: QualificationsOptions,
      queryParams: this.initQueryParams(),
			tableData: [],
			tableDataCount: 0,
			tableDataLoading: false,
      count: 0,
      // 专业列表
      majorList: [
				{ value: '1',label: '专业1' },
				{ value: '2',label: '专业2' },
				{ value: '3',label: '专业3' },
				{ value: '4',label: '专业4' },
				{ value: '5',label: '专业5' },
				{ value: '6',label: '专业6' },
				// { value: '7',label: '备选' },
				{ value: '8',label: '取消' },
			],
			majorDisabled: [], // 不可选专业列表
      disabledFlag: false,
      showHealthDialog: false,
      showStatementDialog: false,
      allMajorVisible: false,
      allMajorSchoolInfo: {},
      allMajorBatchList: [],
      allMajorLoading: false,
      allMajorHighlightCode: '',
      // 弹窗上下文的 majorDisabled：弹窗只展示一个院校，所以这列仅是当前 group 已选专业的 sort 列表
      allMajorMajorDisabled: [],
      // 弹窗打开前的方案快照：用于「取消」时回滚 childrenData 状态
      allMajorSnapshot: null,
		}
  },
	filters: {
		sortType2CN(type) {
			return {
				1: '按院校排序',
				2: '按专业组排序',
			}[type] || '请选择'
		},
	},

  created() {

		let examineeId = this.$route.query.examineeId

		this.$api.getMyExamineeProgramme({ stuId: examineeId }).then(res => {
			this.examineeProgramme = res.data
		})
    const user = localStorage.getItem("stu");
		this.user = JSON.parse(user)
    this.queryParams.precedence = this.user.precedence
    // this.stopF5Refresh();
		if (JSON.parse(this.$route.query.student != null)) {
			// this.dialogVisible = false
			this.studentInfo = JSON.parse(this.$route.query.student);
      // 用于记录 programmeId
			this.programmes = JSON.parse(this.$route.query.student);
			this.childrenData = [...this.studentInfo]
      // 过滤新增时的无用数据
      this.childrenData = this.childrenData.filter(item => ![null, undefined,''].includes(item.schoolCode))
			this.studentInfo[0].majorType = JSON.stringify(this.studentInfo[0].majorType)
			if (this.studentInfo[0].schemeRecruitType) {
				this.queryParams.recruitType = this.studentInfo[0].schemeRecruitType.split(',')
				this.recruitType.default = this.studentInfo[0].schemeRecruitType.split(',')
			}

      if(this.studentInfo[0].batch !== '本科普通批平行' && this.studentInfo[0].batch !== '高职专科普通批'){
        this.queryParams.recruitType = [this.studentInfo[0].recruitType];
      }
      //本科提前批单设只能选择一个专业
      if(this.studentInfo[0].batch === '本科提前批单设'){
        this.majorList = [{value: '1', label: '专业1'}, {value: '8', label: '取消'}];
      }else if(this.studentInfo[0].batch === '本科提前批平行' && this.queryParams.recruitType.includes('特殊院校')){
        this.majorList = [{value: '1', label: '专业1'}, {value: '2', label: '专业2'}, {value: '3', label: '专业3'}, {value: '8', label: '取消'}];
      }

			let tabItem = this.tabs.list.find(item => item.label === this.studentInfo[0].batch)
			if (tabItem) {
				this.tabs.active = tabItem.value
			}
			if (this.studentInfo[0].batch.indexOf('提前') !== -1) {
				this.tqfrom = true
				this.ptfrom = false
			} else {
				this.tqfrom = false
				this.ptfrom = true
			}
      // 设置列表请求参数
      this.queryParams.fraction = this.studentInfo[0].score
      this.queryParams.precedence = this.studentInfo[0].precedence
      this.queryParams.schemePrecedence = this.studentInfo[0].precedence
      this.queryParams.recruitType = this.studentInfo[0].schemeRecruitType?.split(',') || []
      this.queryParams.majorType = this.studentInfo[0].majorType
		}
    if (this.studentInfo[0].batch.indexOf('提前') !== -1) {
      this.disabledFlag = true;
    }
		if (this.user.subject1 != undefined && this.user.subject1 !=''
				&& this.user.subject2 != undefined && this.user.subject2 !='') {
			this.queryParams.subject = [this.user.subject1, this.user.subject2]
		}
    // 从预览页重新进入时，回填上次点击预览时记录的搜索条件
    this.restoreQueryParams()
    this.getTableData().then(res => {
      if (this.queryParams.precedence == null || this.queryParams.precedence == "") {
        let findIndex = this.tableData.findIndex((item) => item._schemeChecked)
        findIndex !== -1 && this.$refs.virtualScroll.scrollTo(findIndex)
      }
		})
    this.getDataYearOfDict()
  },

  mounted() { },
  methods: {
    initQueryParams() {
      return {
        school: '', 	// 院校名称
        checkGroupCode: '', 	// 专业组code
        // schoice: 'W', // 首选科目
        majorType: '1', // 首选科目
        subject: ['化学','生物'], // 再选科目
        recruitType: ['普通志愿', '中外合办', '定向就业'],  // 类别
        city: [],
        type: [],
        nature: [],
        hierarchys: [],
        qualifications: [],
        major1: '', 			// 专业1
        major2: '', 			// 专业2
        major3: '', 			// 专业3
        major4: '', 			// 专业4
        major5: '', 			// 专业5
        fraction: null,   // 分数
        precedence: null, // 位次
        sortType: 2, // 按学校名称排序 向上就传1 向下传2
        queryType: 1,     // 1 定位查询 2 筛选查询
        searchMajorNum: '', // 专业查询量
        addType: '',        // 1：院校 2：专业
        queryRecruitType: '', // 1：只查合办 2：屏蔽合办
        querySubject: '', // 1：只查不限 2：屏蔽不限
        queryPlan: '', // 传数字10、20、30、40
        maxScore: null,
        minScore: null,
        maxPrecedence: null,
        minPrecedence: null,
        queryMajorTypes: [],
        queryMajor: [],
        schemePrecedence: null, // 方案位次
      }
    },
		handleReset() {
      this.queryParams = {
				...this.queryParams,
				school: '', 	// 院校名称
				checkGroupCode: '', 	// 专业组code
				// subject: ['化学','生物'], // 再选科目
				// recruitType: ['不限'],  // 类别
        city: [],
        type: [],
        nature: [],
        hierarchys: [],
        qualifications: [],
				major1: '', 			// 专业1
				major2: '', 			// 专业2
				major3: '', 			// 专业3
        major4: '', 			// 专业4
        major5: '', 			// 专业5
        fraction: null,   // 分数
        precedence: null, // 位次
				sortType: 2, // 按学校名称排序 向上就传1 向下传2
        queryType: 1, 		// 定位查询 1 筛选查询 2
        searchMajorNum: '', // 专业查询量
        addType: '',        // 1：院校 2：专业
        queryRecruitType: '', // 1：只查合办 2：屏蔽合办
        querySubject: '', // 1：只查不限 2：屏蔽不限
        queryPlan: '', // 传数字10、20、30、40
        maxScore: null,
        minScore: null,
        maxPrecedence: null,
        minPrecedence: null,
        queryMajorTypes: [],
        queryMajor: []
      }
			// 清空子组件的selectedMajorData
			this.$refs.searchPanel.clearSelectedMajorData();
      // 清空子组件的分数位次数据
      this.$refs.searchPanel.clearScoreData()
			// this.tabs.active = '本科普通批平行'
			//重置之后自动搜索返回顶部
			this.getTableData();
			this.goTableTop();
		},

		getDataYearOfDict() {
			this.$api.getDict({ dictType: this.tabs.active }).then(res => {
				if (![0, 200].includes(res.code)) {
					return this.$message.error(res.msg)
				}
				res.data.forEach(item => {
					if(item.dictName === 'now'){
						this.nowYear = item.dictValue
					}else if (item.dictName == "plan") {
						this.PlanYear = item.dictValue
					}
					else if (item.dictName == "majornow") {
						this.MajorNowYear = item.dictValue
					} else if (item.dictName == "majorplan") {
						this.MajorPlanYear = item.dictValue
					}
				})
			})
		},

    resetSearchResult() {
      this.searchResult = {
        currentCode: '',
        list: [],
      }
    },
    // 获取当前currentCode下标
    getSearchIndexByCurrentCode () {
      if (!this.searchResult.currentCode) return
      let index = this.searchResult.list.findIndex(item => item === this.searchResult.currentCode);
      return index + 1
    },

    // 检索结果上一个下一个
    toNextResultFn(number) {
      const searchIndex = this.searchResult.list.findIndex(item => item === this.searchResult.currentCode);
      let toIndex = searchIndex + number
      if (searchIndex + number < 0) {
        toIndex = this.searchResult.list.length - 1
      }
      else if (searchIndex + number >= this.searchResult.list.length) {
        toIndex = 0
      }
      let realCode = this.searchResult.list[toIndex]
      this.searchResult.currentCode = realCode
      let realIndex = this.tableData.findIndex(item => `${item.code}-${item.groupCode}` === realCode)
      this.$refs.virtualScroll.scrollTo(realIndex)
    },

    setCurrentCodeFontColor(code) {
      let classes = '';
      if (this.searchResult.currentCode === code) {
        classes = 'searchResult-currentCode'
      }
      return classes;
    },

		getTableData() {
			if(this.queryParams.subject.length < 2){
				this.$message.error('再选科目不得少于两个！');
				return Promise.reject(res)
			}
      this.resetSearchResult()
			this.tableDataLoading = true
      if(this.tabs.active === '高职专科普通批'){
        this.queryParams.recruitType = [];
      }
			return request({
				method: 'post',
				url: '/schoolV2/getSchoolInformations',
				data: {
					...this.queryParams,
          stuId: this.user.id,
					batch: this.tabs.active,
					majorType: [1, 3].includes(this.programmes[0].majorType) ? 1 : 2,
				}
			}).then(res => {
				if (![0, 200].includes(res.code)) {
					this.$message.error(res.msg)
					return Promise.reject(res)
				}
				if (this.tableData) {
					res.data.forEach(item => {
						item.schemeName = ''
            item.schemeNum = ''
						item._schemeChecked = false
						this.childrenData.forEach(subItem => {
							if (item.code == subItem.schoolCode && item.groupCode == subItem.groupCode) {
								item.schemeName = subItem.schemeName
                item.schemeNum = subItem.schemeNum
								item._schemeChecked = true
							}
						})
					})
					this.schoolCheckedNumber = this.getSchoolCheckedNumber()
				}
				this.tableData = res.data
				this.tableDataCount = res.searchTotal
				this.tableDataLoading = false
        let result = this.tableData.filter(item => item.color === 1)
        this.searchResult.list = result.map(item => `${item.code}-${item.groupCode}`)
				this.dingweiSchool()
				return res
			})
		},

		// 分数和位次在表格中的定位
		dingweiSchool(){
      const scrollToRowByIndex = (index) => {
        if (index === -1) {
          // return this.$message.error('在您设定的分数/位次区间内，暂无符合条件的筛选结果！');
          return;
        }
        setTimeout(() => {
          this.$refs.virtualScroll.scrollTo(index)
        }, 200);
        if (this.searchResult.list.length > 0) {
          this.searchResult.currentCode = `${this.tableData[index].code}-${this.tableData[index].groupCode}`
        }
      }
			if(this.queryParams.school != null && this.queryParams.school != ""){
				let batch='普通';
				if(this.tabs.active.indexOf('提前') !== -1){
					batch="提前";
				}
				let checkGroupCode = this.queryParams.checkGroupCode;
        let index = 1;
        this.tableData.forEach((data, dataIndex) => {
          if(checkGroupCode != ''){
            if(data.schoolName == this.queryParams.school && data.groupCode == checkGroupCode){
              if(index == 1){
                index = dataIndex;
              }
              data.color = 1;
              this.searchResult.list.push(`${data.code}-${data.groupCode}`);
            }
          }else if(data.schoolName == this.queryParams.school){
            if(index == 1){
              index = dataIndex;
            }
            data.color = 1;
            this.searchResult.list.push(`${data.code}-${data.groupCode}`);
          }
        });
				scrollToRowByIndex(index)
			}else if(this.queryParams.precedence!=null&&this.queryParams.precedence!=""){
				let batch = '普通';
				if(this.tabs.active.indexOf('提前') !== -1){
					batch = "提前";
				}
				this.queryParams.fraction = null;
				let precedence = this.queryParams.precedence;
        if (this.queryParams.minPrecedence != '' && Number(this.queryParams.precedence) < Number(this.queryParams.minPrecedence)) {
          scrollToRowByIndex(-1);
          return;
        }
				let index = this.tableData.findIndex(i => {
          if(this.queryParams.sortType == 1){
            if(precedence <= i.proposedwc){
              i.newColor = 2
              return true
            }
          }else {
            if(precedence <= i.groupProposedwc){
              i.newColor = 2
              return true
            }
          }
				});
        scrollToRowByIndex(index)
			}else if(this.queryParams.fraction != null && this.queryParams.fraction != ""){
				let batch='普通';
				if(this.tabs.active.indexOf('提前') !== -1){
					batch="提前";
				}
				this.queryParams.precedence=null;
				let isOne = 0;
				let findIndex = null
				let fraction = this.queryParams.fraction;
        if (this.queryParams.maxScore != '' && this.queryParams.maxScore != null && Number(this.queryParams.fraction) > Number(this.queryParams.maxScore)) {
          scrollToRowByIndex(-1);
          return;
        }
				while(isOne==0){
					findIndex = this.tableData.findIndex(i=>{
            if(this.queryParams.sortType == 1){
              if(i.proposedScore==fraction){
                i.newColor = 2
                isOne=1;
                return true
              }
            }else{
              if(i.groupProposedScore==fraction){
                i.newColor = 2
                isOne=1;
                return true
              }
            }
					})
					if(fraction>150){
						fraction--;
					}else{
						isOne=1;
					}
				}
        scrollToRowByIndex(findIndex)
			}else {
				let batch = '普通';
				if(this.tabs.active.indexOf('提前') !== -1){
					batch = "提前";
				}
				let index = this.tableData.findIndex(i => i.color == 1);
				index !== -1 && scrollToRowByIndex(index)
			}
		},
		getSchoolCheckedNumber() {
			return this.childrenData.filter(item => ![null, undefined,''].includes(item.schoolCode)).length
		},
		sortTable(command) {
			this.queryParams.sortType = command
			this.getTableData()
		},

		toggleExpand(row) {
      let tableDataIndex = this.tableData.findIndex(item => item.id == row.id)
			if (!row.$v_expanded) {
        // 先关闭所有
        this.tableData.filter(item => item.$v_expanded === true).forEach(item => {
          this.$refs.virtualScroll.toggleRowExpansion(item, false)
        })
				let majorType = this.programmes != null && this.programmes.length > 0 && this.programmes[0].majorType != null ? this.programmes[0].majorType : this.user.major
				request({
					method: 'post',
					url: 'schoolV2/getSchoolMajor',
					data: {
            schemePrecedence: this.programmes[0].precedence,
            schoolCode: row.code,
						majorType: [1, 3].includes(majorType) ? 1 : 2,
						major1: this.queryParams.major1,
						major2: this.queryParams.major2,
						major3: this.queryParams.major3,
            major4: this.queryParams.major4,
            major5: this.queryParams.major5,
						groupCode: row.groupCode,
            queryMajorTypes: this.queryParams.queryMajorTypes,
            batch: row.batch,
            stuId: this.user.id,
            queryMajor: this.queryParams.queryMajor,
          }
				}).then(res => {
					res.data.map(item => {
						item.sort = ''
						item._isChecked = false
					})
					this.$set(this.tableData[tableDataIndex], "children1", res.data)
					this.majorDisabled = []
					this.childrenData.filter(item =>
						this.tableData[tableDataIndex].code == item.schoolCode &&
						this.tableData[tableDataIndex].groupCode == item.groupCode
					).forEach(item => {
						if (!['', null, undefined].includes(item.majorList)) {
							res.data.forEach(o => {
								let majorIndex = item.majorList.findIndex(majorItem => majorItem.majorCode === o.majorCode || majorItem.uniqueCode === o.uniqueCode)
								if (majorIndex !== -1) {
									o.sort = item.majorList[majorIndex].sort
									o._isChecked = true
								}
							})
              this.majorDisabled = res.data.filter(item => !['', null, undefined].includes(item.sort)).map(item => item.code+"_"+item.groupCode+"_"+item.sort)
            }
					})
					this.$refs.virtualScroll.toggleRowExpansion(row)
          this.$refs.virtualScroll.scrollTo(tableDataIndex)
					this.$refs.virtualScroll.update()
				})
			} else {
				this.majorDisabled = []
        this.$refs.virtualScroll.scrollTo(tableDataIndex)
				this.$refs.virtualScroll.toggleRowExpansion(row)
				this.$refs.virtualScroll.update()
			}
    },
		// 执行点击行调用的方法，展开和折叠行
		clickTable(row, index) {
			let state = false
			// state = true 收起时清空children数据
			let result = this.tableData.find(item => item.id == row.id)
			if (result && result.children != null) {
				state = true
				result.children = null
			}
			row.isExpanded = state
			if (state == false) {
				this.getSchoolMajor(row, index)
			} else {
				this.$refs.multipleTable && this.$refs.multipleTable.toggleRowExpansion(row)
				this.$refs.multipleTable1 && this.$refs.multipleTable1.toggleRowExpansion(row)
				this.$refs.multipleTable2 && this.$refs.multipleTable2.toggleRowExpansion(row)
			}

		},

		getSchoolMajor(row) {
			let majorType = this.programmes != null && this.programmes.length > 0 && this.programmes[0].majorType != null ? this.programmes[0].majorType : this.user.major
			request({
				method: 'post',
				url: 'schoolV2/getSchoolMajor',
				data: {
          schemePrecedence: this.programmes[0].precedence,
          schoolCode: row.code,
					majorType: [1, 3].includes(majorType) ? 1 : 2,
					major1: this.queryParams.major1,
					major2: this.queryParams.major2,
					major3: this.queryParams.major3,
          major4: this.queryParams.major4,
          major5: this.queryParams.major5,
					groupCode: row.groupCode,
          queryMajorTypes: this.queryParams.queryMajorTypes,
          batch: row.batch,
          queryMajor: this.queryParams.queryMajor,
        }
			}).then(res => {
				let tableDataIndex = this.tableData.findIndex(item => item.id == row.id)
				res.data.map(item => {
					item.sort = ''
					item._isChecked = false
				})
				this.$set(this.tableData[tableDataIndex], "children", res.data)
				this.childrenData.forEach(item => {
					if (this.tableData[tableDataIndex].code == item.schoolCode && this.tableData[tableDataIndex].groupCode == item.groupCode) {
						if (!['', null, undefined].includes(item.majorList)) {
							for (var r = 0; r < item.majorList.length; r++) {
								res.data.forEach(o => {
									if (item.majorList[r].majorCode == o.majorCode) {
										o.sort = item.majorList[r].sort
										o._isChecked = true
									}
								})
							}
						}
					}
				})
				this.$forceUpdate()
				this.$refs.multipleTable && this.$refs.multipleTable.toggleRowExpansion(row)
				this.$refs.multipleTable1 && this.$refs.multipleTable1.toggleRowExpansion(row)
				this.$refs.multipleTable2 && this.$refs.multipleTable2.toggleRowExpansion(row)
			})
		},

		// 搜索后高亮显示某行
		cellStyle({ row, column, rowIndex, columnIndex }) {
			let styleClass = ''
			// color:1 td checkbox搜索结果匹配时
			// newColor === 2 td分数与位次的激活样式
			if (row.newColor === 2){
				styleClass += `backgroundColor: var(--orange01); color: blue`;
			}else if (row.color === 1){
				styleClass += `backgroundColor: var(--orange01);`;
			}
			//招生类别样式
			if (this.tabs.active == "本科普通批平行" && !defaultRecruitType.includes(row.recruitType) && column.property=="recruitType"){
				styleClass += `color: #39B830`;
			}
			return styleClass
		},
		// 搜索后高亮显示某行--用于展开后的表格样式
		cellStyles({ row, column, rowIndex, columnIndex }) {
			let styleClass = ''
			if (row.color === 'red') {
				styleClass = `color: var(--primaryColor)`;
			}
			return styleClass
		},

		showDate(val, batch) {
			if (this.schoolBoolen != true) {
				return val
			}
			val = val + '';
			if (val.indexOf(this.queryParams.school) !== -1 && this.queryParams.school !== '') {
				if (batch == "提前") {
					return val.replace(this.queryParams.school, '<em class="Tqseat">' + this.queryParams.school + '</em>')
				} else if (batch == "特殊") {
					return val.replace(this.queryParams.school, '<em class="Tsseat">' + this.queryParams.school + '</em>')
				}
				return val.replace(this.queryParams.school, '<em class="Ptseat">' + this.queryParams.school + '</em>')
			}
			return val
		},

    introduceMajor(majorDesc) {
      this.schoolIntroduce.data = majorDesc;
      this.schoolIntroduce.type = 'major'
      this.schoolIntroduce.open = true
    },
    introduceSchool(code) {
      request({
        method: 'get',
        url: 'schoolV2/getSchoolBaseDetail?code='+code,
      }).then(res => {
        if (res.code === 0 && res.data) {
          this.schoolIntroduce.type = 'school'
          this.schoolIntroduce.schoolDesc = res.data.schoolDesc ? res.data.schoolDesc : ''; // 院校简介
          this.schoolIntroduce.constitution = res.data.constitution ? res.data.constitution : ''; // 章程摘要
          this.schoolIntroduce.policy = res.data.policy ? res.data.policy : ''; // 招生政策
          this.schoolIntroduce.specialClass = res.data.specialClass ? res.data.specialClass : ''; // 特殊班型
          this.schoolIntroduce.warning = res.data.warning ? res.data.warning : ''; // 院校预警
          this.schoolIntroduce.open = true
        }
      })
    },

    tableTrClassName(row) {
			let batch = "普通";
			if (['本科提前单设', '本科提前平行', '高职专科提前'].includes(this.batch)) {
				batch = "提前";
			} else if (['一批特殊', '二批特殊'].includes(this.batch)) {
				batch = "特殊";
			}
			let name = batch + row.row.code + row.row.groupCode + 'school'
			return name;
		},

		details(row) {
			const infos = row;
			localStorage.setItem('infos', JSON.stringify(infos))
			const routeData = this.$router.resolve({
        name: 'schoolV2Detail',
				params: {
					info: infos
				}
			})
			window.open(routeData.href, '_blank')
		},

		// 选志愿
		schemeChange(value, scope) {
			// 兼容列表/弹窗：弹窗内 row 可能不在 tableData 中
			const rowRef = scope && scope.row ? scope.row : scope
			if (!value) {
				let findIndex = this.childrenData.findIndex(item => (item.schoolCode === rowRef.code && item.groupCode === rowRef.groupCode))
				if (findIndex !== -1) {
          // 重置childrenData数字
          this.childrenData.slice(findIndex + 1).map(item => {
            item.schemeNum = item.schemeNum - 1
          })
          this.childrenData.splice(findIndex, 1);
          // 重置tableList数字
          this.tableData
            .filter(item => item._schemeChecked === true)
            .filter(item => item.schemeNum >= rowRef.schemeNum)
            .forEach(item => {
              item.schemeNum = item.schemeNum - 1
            })
          // 清空
          rowRef.schemeNum = '';
          rowRef.children1 && rowRef.children1.forEach(item => {
            item.sort = '';
          });
          this.majorDisabled = [];
				}
				this.schoolCheckedNumber = this.getSchoolCheckedNumber()
			} else {
				let maxChecked = 50
				if (this.tabs.active === '本科提前批平行') {
          if(this.queryParams.recruitType.includes('军队院校') ||  this.queryParams.recruitType.includes('公安院校') || this.queryParams.recruitType.includes('其他院校')){
            maxChecked = 6
          }else if(this.queryParams.recruitType.includes('特殊院校')){
            maxChecked = 1
          }
				} else if (this.tabs.active === '本科提前批单设' || this.tabs.active === '本科普通批单设') {
          maxChecked = 1
        } else if (this.tabs.active === '高职专科提前批') {
          maxChecked = 6
        }
				if (this.schoolCheckedNumber >= maxChecked) {
					this.$message.error(`最多只能选${maxChecked}个院校专业组`)
					rowRef._schemeChecked = false
					return
				}

				let result = this.childrenData.find(item => (item.schoolCode === rowRef.code && item.groupCode === rowRef.groupCode))
        rowRef.schemeNum = this.childrenData.length + 1
				if (!result) {
					// 列表点：rowRef 在 tableData；弹窗点：rowRef 不在 tableData，也带全字段，直接用即可
					const index = this.tableData.findIndex(item => item.code === rowRef.code && item.groupCode === rowRef.groupCode)
					const baseData = index !== -1 ? this.tableData[index] : rowRef
					this.childrenData.push({
            "schemeNum": rowRef.schemeNum,
            "schemeName": baseData.schemeName,
						"schoolName": baseData.schoolName,
						"schoolCode": baseData.code,
						"plan2022": baseData.plan2022,
						"majorPlan": baseData.majorPlan,
						"num": this.programmes[0].num,
						"majorType": this.programmes[0].majorType,
						"stuId": this.user.id,
						"groupCode": baseData.groupCode,
						"recruitType": baseData.recruitType,
					})
				}
			}
			this.schoolCheckedNumber = this.getSchoolCheckedNumber()
		},
		// 弹窗内触发：转调现有 schemeChange，让其复用 childrenData / children1 同步逻辑
		dialogSchemeChange(value, row) {
			this.schemeChange(value, { row })
			// 弹窗里的 row 与列表里的 row 不是同一个对象，统一按 childrenData 回写到列表
			this.syncDialogSchemeToTable()
		},
		// 弹窗内触发：转调现有 majorchange，让其复用 childrenData 中院校 + 专业增删逻辑
		dialogMajorChange(parentRow, childRow, label) {
			this.majorchange(parentRow, childRow, label)
			this.syncDialogSchemeToTable()
		},
		// 把 childrenData 里的方案状态回写到列表行（院校勾选/已选序号 + 专业已选序）
		// 保证弹窗里选完院校、专业后，列表界面的展示与之一致
		syncDialogSchemeToTable() {
			if (!Array.isArray(this.tableData)) return
			this.tableData.forEach(row => {
				if (!row || !row.code) return
				const chosen = (this.childrenData || []).find(it =>
					String(it.schoolCode) === String(row.code) && String(it.groupCode) === String(row.groupCode)
				)
				this.$set(row, '_schemeChecked', !!chosen)
				this.$set(row, 'schemeNum', chosen ? chosen.schemeNum : '')
				const majorList = chosen && Array.isArray(chosen.majorList) ? chosen.majorList : []
				;(row.children1 || []).forEach(major => {
					if (!major) return
					const hit = majorList.find(m =>
						(m.majorCode != null && major.majorCode != null && String(m.majorCode) === String(major.majorCode)) ||
						(m.uniqueCode != null && major.uniqueCode != null && String(m.uniqueCode) === String(major.uniqueCode))
					)
					this.$set(major, 'sort', hit ? hit.sort : '')
					this.$set(major, '_isChecked', !!hit)
				})
			})
		},

		// 选专业
		majorchange(parentRow, childRow, label) {
			let schoolItem = this.childrenData.find(item => (item.schoolCode == parentRow.code && item.groupCode == parentRow.groupCode))
			// 是否已选择该学校
			if (!schoolItem || !parentRow._schemeChecked) {
				return this.$message.error('请先选择学校');
			}

			if (label === "取消") {
				this.childrenData
					.filter(item => item.schemeName != null)
					.forEach((item, index) => {
						if (parentRow.code == item.schoolCode && parentRow.groupCode == item.groupCode) {
							let majorIndex = item.majorList.findIndex(child => child.majorCode === childRow.majorCode || child.uniqueCode === childRow.uniqueCode)
							if (majorIndex !== -1) {
								let deletedItem = item.majorList.splice(majorIndex, 1)
                this.majorDisabled.indexOf(parentRow.code+"_"+parentRow.groupCode+"_"+deletedItem[0].sort) !== -1 && this.majorDisabled.splice(this.majorDisabled.indexOf(parentRow.code+"_"+parentRow.groupCode+"_"+deletedItem[0].sort), 1)
              }
						}
					})
				childRow.sort = null
				childRow.majorName = childRow.majorName + ' '
				this.$set(childRow, 'sort', null)
			} else if (label === '备选') {
				if (!parentRow.schemeName.length) return
				this.childrenData
					.filter(item => item.schemeName != null)
					.forEach((item, index) => {
						if (parentRow.code == item.schoolCode && parentRow.groupCode == item.groupCode) {
							let majorIndex = item.majorList.findIndex(child => child === childRow.majorCode || child.uniqueCode === childRow.uniqueCode)
							item.majorList.splice(majorIndex, 1)
						}
					})
				this.childrenData.forEach(i => {
					if (parentRow.code == i.schoolCode && parentRow.groupCode == i.groupCode) {
						if (!i.majorList) {
							i.majorList = []
						}
						i.majorList.push({
							"sort": label,
							"majorName": childRow.majorName,
							"majorCode": childRow.majorCode,
							"plan2018": childRow.plan2018,
							"majorLimit": childRow.majorLimit,
							"uniqueCode": childRow.uniqueCode
						})
            this.majorDisabled.push(childRow.code+"_"+childRow.groupCode+"_"+label);
          }
				})
				this.$set(childRow, 'sort', label)
				childRow.sort = label
				childRow.majorName = childRow.majorName + ' '
			} else {
				if (!Array.isArray(schoolItem.majorList) || schoolItem.majorList.length === 0) {
					this.childrenData.forEach(i => {
						if (parentRow.code == i.schoolCode && parentRow.groupCode == i.groupCode) {
							if (!i.majorList) {
								i.majorList = []
							}
							i.majorList.push({
								"sort": label,
								"majorName": childRow.majorName,
								"majorCode": childRow.majorCode,
								"plan2018": childRow.plan2018,
								"majorLimit": childRow.majorLimit,
                "uniqueCode": childRow.uniqueCode
							})
						}
					})
					this.$set(childRow, 'sort', label)
          this.majorDisabled.push(childRow.code+"_"+childRow.groupCode+"_"+label);
					return
				}
				// majorList：专业列表
				else if (Array.isArray(schoolItem.majorList) && schoolItem.majorList.length > 0) {
					// step1.如果有相同的专业1 则清空sort
					parentRow.children1.map(item => {
						if (item.sort === label) {
							this.$set(item, 'sort', '')
              this.majorDisabled.indexOf(item.code+"_"+item.groupCode+"_"+item.sort) !== -1 && this.majorDisabled.splice(this.majorDisabled.indexOf(item.code+"_"+item.groupCode+"_"+item.sort), 1)
						}
					})
					// step2. 如果已经选了专业1 则删除schoolItem.majorList以前的专业1
					let sortIndex = schoolItem.majorList.findIndex(item => item.sort === label)
					if (sortIndex !== -1) {
						schoolItem.majorList.splice(sortIndex, 1);
            this.majorDisabled.indexOf(schoolItem.majorList[sortIndex].code+"_"+schoolItem.majorList[sortIndex].groupCode+"_"+schoolItem.majorList[sortIndex].sort) !== -1 && this.majorDisabled.splice(this.majorDisabled.indexOf(schoolItem.majorList[sortIndex].code+"_"+schoolItem.majorList[sortIndex].groupCode+"_"+schoolItem.majorList[sortIndex].sort), 1)
					}
					// 如果将专业1更改为专业2
					for (let z = 0; z < schoolItem.majorList.length; z++) {
						if (schoolItem.majorList[z].majorCode == childRow.majorCode) {
							schoolItem.majorList.splice(z, 1);
              this.majorDisabled.indexOf(childRow.code+"_"+childRow.groupCode+"_"+childRow.sort) !== -1 && this.majorDisabled.splice(this.majorDisabled.indexOf(childRow.code+"_"+childRow.groupCode+"_"+childRow.sort), 1)
						}
					}
					schoolItem.majorList = schoolItem.majorList || []
					schoolItem.majorList.push({
						"sort": label,
						"majorName": childRow.majorName,
						"majorCode": childRow.majorCode,
						"plan2018": childRow.plan2018,
						"majorLimit": childRow.majorLimit,
            "uniqueCode": childRow.uniqueCode
					})
					this.$set(childRow, 'sort', label)
          this.majorDisabled.push(childRow.code+"_"+childRow.groupCode+"_"+label);
					childRow.sort = label
					childRow.majorName = childRow.majorName + ' '
				}
			}
		},

		// 选专业 checkbox
		onChangeMajor(checkStatus, { parentRow, childRow }) {
			let label = '专业' // 专业默认名称
			if (!checkStatus) {
				this.childrenData
					.filter(item => item.schemeName != null)
					.forEach((item, index) => {
						if (parentRow.row.code == item.schoolCode && parentRow.row.groupCode == item.groupCode) {
							let majorIndex = item.majorList.findIndex(child => child === childRow.row.majorCode || child.uniqueCode === childRow.uniqueCode)
							item.majorList.splice(majorIndex, 1)
						}
					})
				childRow.row.sort = null
				childRow.row.majorName = childRow.row.majorName + ' '
				childRow.row._isChecked = false
			} else {
				let schoolItem = this.childrenData.find(item => (item.schoolCode == parentRow.row.code && item.groupCode == parentRow.row.groupCode))
				// 是否已选择该学校
				if (!schoolItem || !parentRow.row._schemeChecked) {
					childRow.row._isChecked = false
					return this.$message.error('请先选择学校');
				}
				if (!Array.isArray(schoolItem.majorList) || schoolItem.majorList.length === 0) {
					this.childrenData.forEach(i => {
						if (parentRow.row.code == i.schoolCode && parentRow.row.groupCode == i.groupCode) {
							if (!i.majorList) {
								i.majorList = []
							}
							i.majorList.push({
								"sort": label,
								"majorName": childRow.row.majorName,
								"majorCode": childRow.row.majorCode,
								"plan2018": childRow.row.plan2018,
								"majorLimit": childRow.row.majorLimit,
                "uniqueCode": childRow.uniqueCode
							})
						}
					})
					this.$set(childRow.row, 'sort', label)
					childRow.row._isChecked = true
					return
				}
				// majorList：专业列表
				else if (Array.isArray(schoolItem.majorList) && schoolItem.majorList.length > 0) {
					schoolItem.majorList = schoolItem.majorList || []
					schoolItem.majorList.push({
						"sort": label,
						"majorName": childRow.row.majorName,
						"majorCode": childRow.row.majorCode,
						"plan2018": childRow.row.plan2018,
						"majorLimit": childRow.row.majorLimit,
            "uniqueCode": childRow.uniqueCode
					})
					childRow.row.sort = label
					childRow.row.majorName = childRow.row.majorName + ' '
					childRow.row._isChecked = true
				}
			}
		},

		filterSaveScheme() {
			this.childrenData = this.childrenData.filter(item => ![null, undefined,''].includes(item.schoolCode))
			const res = new Map();
			//按照schoolCode和groupCode过滤
			this.childrenData = this.childrenData.filter((arr) => !res.has(arr.schoolCode+"_"+arr.groupCode) && res.set(arr.schoolCode+"_"+arr.groupCode, 1));
			let sortList = []
			let bList = []
			for (var i = 0; i < this.childrenData.length; i++) {
        this.childrenData[i].notMajorList = null;
				if (this.childrenData[i].schemeName == "备选") {
					bList.push(this.childrenData[i])
				} else {
					sortList.push(this.childrenData[i])
				}
			}
			bList.forEach(i => {
				sortList.push(i)
			})
			this.childrenData = sortList
		},

		saveScheme() {
      this.saveSchemeAsync(false);
		},
    saveSchemeAsync(flag) {
      this.tableData.filter(item => item.$v_expanded === true).forEach(item => {
        this.$refs.virtualScroll.toggleRowExpansion(item, false)
      })
      this.$refs.virtualScroll.update()
      this.filterSaveScheme()
      this.scheme = []
      if (this.childrenData != undefined && this.childrenData.length > 0) {
        this.childrenData.forEach(i => {
          this.scheme.push({
            ...i,
            "schoolName": i.schoolName,
            "schoolCode": i.schoolCode,
            "plan2022": i.plan2022,
            "majorPlan": i.majorPlan,
            "majorList": i.majorList ? JSON.stringify(i.majorList).toString() : null,
            "programmeName": this.programmes[0].programmeName,
            "schemeName": i.schemeName,
            "programmeId": this.programmes[0].programmeId,
            "stuId": this.user.id,
            "score": this.user.score,
            "precedence": this.user.precedence,
            "batch": this.programmes[0].batch,
            "num": i.num,
            "majorType": i.majorType,
            "groupCode": i.groupCode,
            "recruitType": i.recruitType
          })
        })
      } else {
        return;
      }
      //判断提交的学校专业是否有重复，有重复去重
      this.scheme.forEach(data=>{
        if(data.majorList && data.majorList.length > 0){
          var filterMajorList = this.removeDuplicatesByProperty(JSON.parse(data.majorList), 'majorCode');
          data.majorList = JSON.stringify(filterMajorList).toString();
        }
      });

      request({
        method: 'post',
        url: 'stuSchemeV2/saveScheme',
        data: this.scheme
      }).then(res => {
        if (![0, 200].includes(res.code)) {
          return this.$message.error(res.msg)
        }
        this.$message.success('保存成功！')
        this.programmeId = res.data.list[0].programmeId
        this.xfa = res.data.list
        this.batch = res.data.list[0].batch
        this.num = res.data.list[0].num
        if(flag){
          if (this.programmes != null && this.programmes.length > 0) {
            const infos = this.programmes[0];
            localStorage.setItem('volunteer', JSON.stringify(infos));
            this.$router.push({
              name: 'designV2Preview',
              params: {
                info: infos
              }
            });
          } else {
            const infos = this.xfa[0];
            localStorage.setItem('infos', JSON.stringify(infos));
            this.$router.push({
              name: 'designV2Preview',
              params: {
                info: infos
              }
            });
          }
        }
      })
    },

    handleClick() {
      // 点击预览时记录当前搜索条件，便于从预览页返回后回填
      this.saveQueryParams();
      this.saveSchemeAsync(true);
    },

    // 获取当前方案的唯一标识（优先 mainId，回退 programmeId），用于关联搜索条件缓存
    getSchemeKey() {
      const scheme = (this.programmes && this.programmes[0]) || (this.studentInfo && this.studentInfo[0]) || {}
      const schemeId = scheme.mainId != null ? scheme.mainId : scheme.programmeId
      return schemeId != null && schemeId !== '' ? String(schemeId) : ''
    },

    // 读取搜索条件缓存映射表（单一 key 存储，避免每个方案一个 key 导致无限增长）
    readQueryParamsCache() {
      try {
        const cache = JSON.parse(localStorage.getItem('seniorSchoolQueryParamsCache') || '{}')
        return cache && typeof cache === 'object' ? cache : {}
      } catch (e) {
        return {}
      }
    },

    // 记录当前搜索条件到本地缓存（按方案维度存储，并用 LRU 限制总量）
    saveQueryParams() {
      const schemeKey = this.getSchemeKey()
      if (!schemeKey) return
      try {
        const cache = this.readQueryParamsCache()
        cache[schemeKey] = { t: Date.now(), params: this.queryParams }
        // 最多保留 MAX 个方案的搜索条件，超出则淘汰最旧（回填时也会删除，正常不会堆积）
        const MAX = 20
        const keys = Object.keys(cache)
        if (keys.length > MAX) {
          keys.sort((a, b) => (cache[a].t || 0) - (cache[b].t || 0))
            .slice(0, keys.length - MAX)
            .forEach(k => delete cache[k])
        }
        localStorage.setItem('seniorSchoolQueryParamsCache', JSON.stringify(cache))
      } catch (e) {
        console.warn('记录搜索条件失败', e)
      }
    },

    // 回填当前方案上次记录的搜索条件（从预览页重新进入时调用），回填后即清除，避免影响正常进入
    restoreQueryParams() {
      const schemeKey = this.getSchemeKey()
      if (!schemeKey) return
      try {
        const cache = this.readQueryParamsCache()
        const entry = cache[schemeKey]
        if (!entry) return
        // 消费后删除该方案的缓存，同时回写映射表
        delete cache[schemeKey]
        localStorage.setItem('seniorSchoolQueryParamsCache', JSON.stringify(cache))
        if (entry.params && typeof entry.params === 'object') {
          Object.assign(this.queryParams, entry.params)
        }
      } catch (e) {
        console.warn('回填搜索条件失败', e)
      }
    },

		empty() {
			this.$confirm('此操作将清空所选的志愿, 是否继续?', '提示', {
				confirmButtonText: '确定',
				type: 'warning'
			}).then(() => {
				this.tableData.forEach(i => {
					i.schemeName = null
          i._schemeChecked = false
          if (i.children1) {
            i.children1.forEach(j => {
              j.sort = ''
              j._isChecked = false
            })
          }
				})
				this.childrenData = []
				this.$message({
					type: 'success',
					message: '清空成功!'
				});
			})
		},

		UpperLevel() {
			let info = localStorage.getItem('stu')
			this.$confirm('保存当前方案嘛?', '提示', {
				confirmButtonText: '确定',
				cancelButtonText: '取消',
				type: 'warning'
			}).then(() => {
				this.saveScheme().then(
					this.$router.push({
						path: "/designV2/management",
						params: {
							info: info
						}
					})
				)
			}).catch(() => {
				this.$router.push({
					path: "/designV2/management",
					params: {
						info: info
					}
				})
			});
		},
		goTableTop () {
			this.$refs.virtualScroll.scrollTo(0)
		},
    renderHeader(h, { column }) {
      return h('span', {}, [
        h('span', {}, column.label.split('/')[0]),
        h('br'),
        h('span', {}, column.label.split('/')[1])
      ])
    },
    removeDuplicatesByProperty(arr, property) {
      return arr.reduce((acc, current) => {
        // 检查结果数组中是否已经存在具有相同属性值的对象
        const existing = acc.find(item => item[property] === current[property]);
        if (!existing) {
          // 如果不存在，则添加到结果数组
          acc.push(current);
        }
        return acc;
      }, []);
    },
    // 打开体检限制弹窗
    openHealthDialog () {
      this.showHealthDialog = true
    },
    closeHealthDialog () {
      this.showHealthDialog = false
    },
    // 打开声明弹窗
    openStatementDialog () {
      this.showStatementDialog = true
    },
    closeStatementDialog () {
      this.showStatementDialog = false
    },
    // 关闭院校全部专业弹窗
    // confirmed=true  -> 保留弹窗期间的方案选择（用户点了"确定"）
    // confirmed=false -> 回滚到弹窗打开前的 childrenData 状态（用户取消或直接关闭）
    closeAllMajorDialog (confirmed) {
      if (confirmed !== true && this.allMajorSnapshot) {
        // 取消：还原 childrenData 与相关计数
        this.childrenData = this.allMajorSnapshot.childrenData
        this.schoolCheckedNumber = this.allMajorSnapshot.schoolCheckedNumber
        this.majorDisabled = this.allMajorSnapshot.majorDisabled
        this.allMajorMajorDisabled = this.allMajorSnapshot.allMajorMajorDisabled
        // 注：弹窗内 group.children1 的 sort/_isChecked 不主动还原；
        // 下次打开弹窗时 syncSchemeToGroup 会从 childrenData 重新同步
      }
      // 无论「确定」还是「取消」，都按最终的 childrenData 回写列表，保证弹窗与列表的院校/专业选择一致
      this.syncDialogSchemeToTable()
      this.allMajorSnapshot = null
      this.allMajorVisible = false
      this.allMajorBatchList = []
      this.allMajorSchoolInfo = {}
      this.allMajorHighlightCode = ''
      this.allMajorMajorDisabled = []
    },
    // 打开院校全部专业弹窗
    openAllMajorDialog (row) {
      if (!row || !row.schoolName) return
      // 记录弹窗打开前的快照：用于「取消」时回滚 childrenData 状态
      this.allMajorSnapshot = {
        childrenData: JSON.parse(JSON.stringify(this.childrenData)),
        schoolCheckedNumber: this.schoolCheckedNumber,
        majorDisabled: JSON.parse(JSON.stringify(this.majorDisabled || [])),
        allMajorMajorDisabled: JSON.parse(JSON.stringify(this.allMajorMajorDisabled || []))
      }
      this.allMajorSchoolInfo = {
        schoolName: row.schoolName,
        level: row.level,
        city: row.city,
        manager: row.manager,
        levelMsg: row.levelMsg,
        majorPlan: row.majorPlan,
        rateGraduate: row.rateGraduate,
        limitFlag: row.limitFlag,
        code: row.code,
      }
      this.allMajorVisible = true
      this.allMajorBatchList = []
      this.allMajorLoading = true
      this.allMajorHighlightCode = `${row.code}-${row.groupCode}`
      this.allMajorMajorDisabled = []
      // 只获取当前激活批次下该院校的专业组及专业（各批次表头有差异，故仅按当前批次展示）
      const tab = this.tabs.list.find(t => t.value === this.tabs.active)
      this.getSchoolGroupListByBatch(row, tab)
        .then(batch => {
          this.allMajorBatchList = (batch && batch.groupList && batch.groupList.length > 0) ? [batch] : []
          this.allMajorLoading = false
        })
        .catch(() => {
          this.allMajorLoading = false
        })
    },
    // 获取某批次下该院校的专业组列表（含专业明细）
    getSchoolGroupListByBatch (row, tab) {
      const isAdvance = tab.value.indexOf('提前') !== -1
      return request({
        method: 'post',
        url: '/schoolV2/getSchoolInformations',
        data: {
          ...this.queryParams,
          stuId: this.user.id,
          school: row.schoolName,
          batch: tab.value,
          majorType: [1, 3].includes(this.programmes[0].majorType) ? 1 : 2,
          recruitType: tab.value.indexOf('高职专科普通批') !== -1
            ? [] : (this.queryParams.recruitType || []).filter(item => item !== '不限'),
        }
      }).then(async res => {
        if (![0, 200].includes(res.code)) {
          this.$message.error(res.msg)
          return null
        }
        const groupList = (res.data || []).filter(item => item.schoolName === row.schoolName)
        if (groupList.length === 0) return null
        const withChildren = await Promise.all(groupList.map(g => this.getMajorListByGroup(g, tab.value)))
        return {
          batchName: tab.value,
          isAdvance: isAdvance,
          groupList: withChildren,
        }
      })
    },
    // 获取某个专业组下的专业明细
    getMajorListByGroup (group, batch) {
      let majorType = this.programmes != null && this.programmes.length > 0 && this.programmes[0].majorType != null ? this.programmes[0].majorType : this.user.major
      return request({
        method: 'post',
        url: 'schoolV2/getSchoolMajor',
        data: {
          schemePrecedence: this.programmes[0].precedence,
          schoolCode: group.code,
          majorType: [1, 3].includes(majorType) ? 1 : 2,
          major1: this.queryParams.major1,
          major2: this.queryParams.major2,
          major3: this.queryParams.major3,
          major4: this.queryParams.major4,
          major5: this.queryParams.major5,
          groupCode: group.groupCode,
          queryMajorTypes: this.queryParams.queryMajorTypes,
          batch: batch,
          stuId: this.user.id,
          queryMajor: this.queryParams.queryMajor,
        }
      }).then(res => {
        if ([0, 200].includes(res.code)) {
          group.children1 = res.data || []
        } else {
          group.children1 = []
        }
        // 同步 childrenData 中已选院校 + 专业状态到 group 上，便于预览弹窗直接展示
        this.syncSchemeToGroup(group)
        return group
      })
    },
    // 把 childrenData 中该院校专业组的方案信息同步到 group 上：_schemeChecked/schemeNum、专业 sort/_isChecked
    // 注：弹窗内的 majorDisabled 由弹窗根据 batchList 自计算，无需在此处维护
    syncSchemeToGroup (group) {
      const item = this.childrenData.find(it =>
        it.schoolCode === group.code && String(it.groupCode) === String(group.groupCode)
      )
      if (item) {
        this.$set(group, '_schemeChecked', true)
        this.$set(group, 'schemeNum', item.schemeNum)
      } else {
        this.$set(group, '_schemeChecked', false)
        this.$set(group, 'schemeNum', '')
      }
      if (item && !['', null, undefined].includes(item.majorList)) {
        const list = Array.isArray(item.majorList) ? item.majorList : []
        if (group.children1 && group.children1.length) {
          group.children1.forEach(o => {
            const idx = list.findIndex(m => m.majorCode === o.majorCode || m.uniqueCode === o.uniqueCode)
            if (idx !== -1) {
              this.$set(o, 'sort', list[idx].sort)
              this.$set(o, '_isChecked', true)
            }
          })
        }
      }
    },
  }
}

</script>
<style lang="stylus" scoped>
/* 隐藏展开图标 */
.ui-table /deep/ .el-table__expand-icon {
  display: none;
}
.el-table .el-table__cell {
  padding: 6px 0;
}
</style>
<style lang="stylus" scoped>
.queryParams-row1__group
	/deep/
		.el-checkbox__input.is-checked .el-checkbox__inner
			background-color: #f96630;
			border-color: #f96630;
		.el-checkbox__input.is-checked+.el-checkbox__label
			color: #f96630;
		.el-checkbox__input.is-disabled.is-checked .el-checkbox__inner::after
			border-color: #fff;
.ui-tbHeaderForm-elCheckbox /deep/ .el-checkbox__input.is-disabled.is-checked + span.el-checkbox__label {
	color: #f96630;
}
</style>
<style lang="stylus" scoped>
createIconStyle(size, align = text-top) {
	width size
	height size
	vertical-align align
	flex-shrink 0
}
textLabelStyle() {
	font-size: 14px;
	color: #333;
	flex-shrink: 0;
	margin-right: 15px;
	// line-height: 34px;
}
::v-deep .el-autocomplete-suggestion {
  width: auto !important;
  text-align: left !important;
  margin-left: -5px;
}
.searchResult-currentCode {
  color #f00
}
.searchResult-icon {
  padding 2px
  &:hover {
    background #e1e5fa
    border-radius 4px
  }
}

.txt-red {
  color #f00
}
.font-strong
	font-weight: bold;
.queryParams-row1
	display flex
	align-items: center;
	textLabelStyle()
	// line-height 1
	&__label
		margin-right 15px
		line-height: 1;
	&__group /deep/
		display flex
		align-items center
		.el-radio__input
			font-size: 14px;
		.el-radio__label
			font-size: 14px;
.el-icon-caret-bottom
	color #ccc
	font-size 10px
.icon-top
	color #39B830
.icon-bottom
	color #f56c6c
.icon-info
	createIconStyle(20px)
	cursor pointer
.page
	&-bd
		width BodyMaxWidth
		margin 0 auto 60px auto
		box-sizing border-box
	&-block
		uiBlock();
		padding 5px 20px
		margin-bottom 10px
.breadcrumb
	font-size: 16px;
	font-weight: 400;
	color: #333333;
	padding 19px 23px 19px 23px
	.icon-home
		width 18px
		height 18px
		vertical-align: top;
		margin-right 5px

.el-icon-caret-right
	display none

.ui-tabs /deep/
	margin-right 40px
.collapse
	position relative
	&-ft
		position absolute
		bottom 0
		right 0
		width 100%
		pointer-events none
	&-tags
		margin-right 528px
		/deep/ .el-tag
			margin 10px 10px 0 0

.scheme{
	color: var(--primaryColor);
}
.not-scheme{
	color: #333;
}
.trend-assess {
  display: flex;
  align-items: center;
  flex-direction: column;
  font-size: 12px;
  img {
    width: 42px;
  }
}
.name-tag {
  height: 16px;
  font-size: 10px;
  padding-left: 6px
  span {
    margin-right 10px
  }
}
.school-name-icon {
  width: 16px;
  height: 16px;
  margin-left: 4px;
  vertical-align: -3px;
  cursor: pointer;
  &:hover {
    opacity: 0.75;
  }
}
</style>
